module.exports = __webpack_public_path__ + "static/media/max-silver.f2759431.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/custom-products/airpods/max-silver.png
// module id = 2057
// module chunks = 0